<template>
    <div class="about-container">
        <div class="logo-wrapper">
            <div class="col-4 col-md-4 col-lg-4 logo-container">
                <div class="logo"></div>
            </div>
        </div>
        <h1>About</h1>
        <h3>Version: {{appVersion}}</h3>
    </div>
</template>

<script>
/* global appVersion */

export default {
    name: "About",
    data() {
        return {
            appVersion: appVersion
        }
    }
}
</script>
